import { Tooltip, Typography } from '@mui/material';
import { StyledDiv, StyledIndexContainerDiv, StyledLeadContainer } from '../../Components/Styled/index';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { dateTimeISTFormatter, handleValidateCodevalue } from '../../Utility/constant';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AutoCompleteComponent from '../../Components/AutoCompleteComponenet';
import { reportTypeList } from '../../Utility/constant';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import DataGridTable from '../../Components/DataGrid';
import RefreshIcon from '@mui/icons-material/Refresh';
import { GridActionsCellItem } from '@mui/x-data-grid';
import DownloadIcon from '@mui/icons-material/Download';
import BiztantuLoader from '../../Components/Loader';
import { fetchReportRuns } from '../../Store/Reports/action';
import { post, downloadDocument } from '../../Utility/apiHelperNew';
import { requestHideLoader, requestShowLoader } from '../../Store/Global/action';
import { useSnackbar } from 'notistack';
import './Reports.css';

const ReportPage = () => {
  const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
  const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
  const [reportDetails, setSelectedReportDetails] = useState(null);
  const [requiredDetails, setRequiredDetails] = useState(null);
  const [dataGridData, setDataGridData] = useState([]);
  const isLoading = useSelector(state => state.global.isLoading);
  const reports = useSelector(state => state?.reports?.reports);
  const [selectionModel, setSelectionModel] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  /* ---------------- Load report runs (history) ---------------- */
  const getReports = async () => {
    dispatch(fetchReportRuns({}));
    
  };

  useEffect(() => {
    getReports();
  }, []);

  useEffect(() => {
    const reportsData = (reports || []).map((item,index)=>{
      return {
        ...item,
      }
    })
    setDataGridData(reportsData);
  }, [reports]);

  /* ---------------- Handlers ---------------- */

  const handleTypeChange = (event, Type) => {
    setSelectedReportDetails({
      ...reportDetails,
      reportCode: Type,
    });
  };

  const handleOnChange = (event) => {
    const { name, value } = event?.target;
    setSelectedReportDetails({
      ...reportDetails,
      [name]: value,
    });
  };

  /* ---------------- Generate report ---------------- */

  const handleGenerateReport = async () => {
    if (
      !reportDetails?.reportCode ||
      !reportDetails?.dateFrom ||
      !reportDetails?.dateTo
    ) {
      setRequiredDetails({
        reportCode: true,
        dateFrom: true,
        dateTo: true,
      });
      enqueueSnackbar(
        handleValidateCodevalue(internationalise, 'COMMON_MSG_MANDATORY_FIELDS'),
        { variant: 'error' }
      );
      return;
    }

    dispatch(requestShowLoader());
    try {
      const url = `${process.env.REACT_APP_BASE_URL}api/reports/generate/${reportDetails?.reportCode?.value}`;

      const payload = {
        dateFrom: reportDetails.dateFrom,
        dateTo: reportDetails.dateTo,
      };

      const response = await post(url, payload, { returnError: true });

      if (response?.status !== 200 ) {
        enqueueSnackbar(
          handleValidateCodevalue(internationalise, 'COMMON_MSG_ERROR'),
          { variant: 'error' }
        );
        return;
      }

      enqueueSnackbar(
        handleValidateCodevalue(internationalise, 'REP_MSG_REQUESTED'),
        { variant: 'success' }
      );

      setSelectedReportDetails({
        dateFrom: '',
        dateTo: '',
      });
      getReports();

    } catch (error) {
      enqueueSnackbar(
        handleValidateCodevalue(internationalise, 'COMMON_MSG_ERROR'),
        { variant: 'error' }
      );
    } finally {
      dispatch(requestHideLoader());
       setRequiredDetails({
        reportCode: false,
        dateFrom: false,
        dateTo: false,
      });
    }
  };

  /* ---------------- Grid ---------------- */

  const columns = [
    {
      field: 'id',
      headerName: handleValidateCodevalue(internationalise, 'REP_REPORT_ID'),
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'reportCode',
      headerName: handleValidateCodevalue(internationalise, 'REP_SEARCH_REP_TYPE'),
      flex: 1,
      minWidth: 150,
      valueGetter:({value})=>{
        if(!value){
          return ""
        }
          return handleValidateCodevalue(internationalise,value)
    }
  },
    {
      field: 'requestedAt',
      headerName: handleValidateCodevalue(internationalise, 'REP_SEARCH_REQ_DATE'),
      flex: 1,
      minWidth: 150,
      valueFormatter: (params) => {
       if (!params?.value) return "";
        return dateTimeISTFormatter(params?.value)
      }},
    {
      field: 'completedAt',
      headerName: handleValidateCodevalue(internationalise, 'REP_SEARCH_GEN_DATE'),
      flex: 1,
      width: 150,
      valueFormatter: (params) => {
       if (!params?.value) return "";
        return dateTimeISTFormatter(params?.value)
      }},
    {
      field: 'expiresAt',
      headerName: handleValidateCodevalue(internationalise, 'REP_SEARCH_EXP_DATE'),
      width: 150,
      flex: 1,
      valueFormatter: (params) => {
       if (!params?.value) return "";
        return dateTimeISTFormatter(params?.value)
      }},
    {
      field: 'rowCount',
      headerName: handleValidateCodevalue(internationalise, 'REP_SEARCH_NO_OF_REC'),
      width: 150,
    },
    {
      field: 'status',
      headerName: handleValidateCodevalue(internationalise, 'REP_SEARCH_STATUS'),
      width: 150,
    },
    {
      field: 'actions',
      type: 'actions',
      width: 90,
      cellClassName: 'actions',
      renderHeader: () => (
        <Tooltip title={handleValidateCodevalue(internationalise, 'COMMON_ACTION')}>
          <DownloadIcon />
        </Tooltip>
      ),
      getActions: (params) => {
      const isCompleted = (params?.row?.status === 'COMPLETED' && params?.row?.rowCount > 0);

          return [
            <GridActionsCellItem
              icon={
                <Tooltip title={handleValidateCodevalue(internationalise, 'COMMON_DOWNLOAD')}>
                    <DownloadIcon />
                </Tooltip>
              }
              disabled={!isCompleted}
              onClick={() =>
                isCompleted &&
                downloadDocument(
                  params.row.id,
                  `${process.env.REACT_APP_BASE_URL}api/reports/download/${params.row.id}`
                )
              }
              color="inherit"
            />,
          ];
        },
    },
  ];

  /* ---------------- Render ---------------- */

  return (
    <BiztantuLoader open={isLoading} isChildren={true}>
      <StyledDiv>
        <StyledLeadContainer>
          <Typography variant="h6" className="mb-20" gutterBottom>
            {handleValidateCodevalue(internationalise, 'REP_SEARCH_TITLE')}
          </Typography>
        </StyledLeadContainer>

        <StyledIndexContainerDiv>
            {specificRolePermission?.isReportManage &&
          <StyledLeadContainer className="reports-filter-container">
            <Stack
              display="flex"
              alignItems="center"
              className="table-header-search"
              padding="10px"
              spacing={2}
              width="60%"
              direction="row"
              backgroundColor="white"
            >
              <AutoCompleteComponent
                isLookup={true}
                optionSet={reportTypeList}
                value={reportDetails?.reportCode  || null}
                onChange={handleTypeChange}
                label={handleValidateCodevalue(internationalise, 'REP_SEARCH_SELECT_TYPE')}
                placeholder={handleValidateCodevalue(internationalise, 'REP_SEARCH_SELECT_TYPE')}
                error={!reportDetails?.reportCode && requiredDetails?.reportCode}
                className="reports-type-autocomplete"
              />

              <TextFiledWithLabel
                name="dateFrom"
                value={reportDetails?.dateFrom}
                label={handleValidateCodevalue(internationalise, 'REP_GEN_DATE_FROM')}
                type="date"
                error={!reportDetails?.dateFrom && requiredDetails?.dateFrom}
                handleOnChange={handleOnChange}
              />

              <TextFiledWithLabel
                name="dateTo"
                value={reportDetails?.dateTo}
                label={handleValidateCodevalue(internationalise, 'REP_GEN_DATE_TO')}
                type="date"
                error={!reportDetails?.dateTo && requiredDetails?.dateTo}
                handleOnChange={handleOnChange}
              />
                <Button
                  // startIcon={<img src={createicon} style={{ height: '15px' }} />}
                  className="biztantu-sec-btn"
                  variant="outlined"
                  onClick={handleGenerateReport}
                >
                  {handleValidateCodevalue(internationalise, 'REP_GENERATE_REPORT')}
                </Button>
            </Stack>

            <Stack
              className="secondry-btn-container"
              width={specificRolePermission?.isReportView ? "5" :  "40%"}
              padding="10px"
              justifyContent="flex-end"
              spacing={2}
              direction="row"
            >
              <Tooltip
                title={handleValidateCodevalue(internationalise, "COMMON_REFRESH")}
                onClick={getReports}
              >
                <Button
                  className="biztantu-sec-btn"
                  variant="outlined"
                >
                  <RefreshIcon />
                </Button>
              </Tooltip>
            </Stack>
          </StyledLeadContainer>
          }

          <DataGridTable 
          isCheckboxReq= {false}
          columns={columns}
          dataGridData={dataGridData}
          selectionModel={selectionModel}
          setSelectionModel={(data) => setSelectionModel(data)}
          />
        </StyledIndexContainerDiv>
      </StyledDiv>
    </BiztantuLoader>
  );
};

export default ReportPage;
